import { render, staticRenderFns } from "./ExpressLabelsTableUserFilter.vue?vue&type=template&id=71849584&scoped=true"
import script from "./ExpressLabelsTableUserFilter.vue?vue&type=script&lang=js"
export * from "./ExpressLabelsTableUserFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71849584",
  null
  
)

export default component.exports